<template>
    <modal className="max-w-sm w-full" @close="handleClose">
        <template #header>
            Move Chart
        </template>
        <template #body>
            <div class="flex flex-wrap my-2">
                <div class="w-full bg-tan-200 text-center py-2 px-2 border mb-2 border-gray-200">
                    <p class="text-base font-bold leading-none text-blue-500">{{ symbolDisplay }}</p>
                </div>
                <div class="w-full">
                    <label for="chartBook">Move Chart To:</label>
                    <select class="form-control form-control-no-shadow" v-model="chartBook">
                        <option value="">Select Book....</option>
                        <option v-for="book in chartBooks" :value="book" :disabled="book.id == chart.interactive_chart_book_id">{{ book.name }}</option>
                    </select>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="flex justify-center">
                <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="handleClose">Cancel</div>
                <div class="btn btn-sm btn-yellow inline-flex mx-1" @click="moveChart">Move</div>
            </div>
        </template>
    </modal>
</template>

<script setup>
import { ref } from 'vue';

// Define props
const props = defineProps({
    chartBooks: {
        type: Array,
        required: true
    },
    chart: {
        type: Object,
        required: true
    }
});

// Define emits
const emit = defineEmits(['close', 'move']);

// Reactive state
const chartBook = ref('');
const symbolDisplay = ref(props.chart.symbol_display);

// Methods
const moveChart = () => {
    const route = window.route('my-folder.chart-book.move-chart', { chart: props.chart });
    axios.post(route, { interactive_chart_book_id: chartBook.value.id })
        .then((response) => {
            emit('move', response.data.chart);
            emit('close');
        }).catch(error => {
            // Error handling
        });
};

const handleClose = () => {
    emit('close');
};
</script>
